/**
 * Sortable strategy that does not project/move item rects.
 * Required when rows stay in place (opacity ghost) and DragOverlay is used —
 * verticalListSortingStrategy would shift collision targets away from the DOM.
 */
export function preserveLayoutStrategy() {
  return null;
}
